import { PolymerElement } from "@polymer/polymer/polymer-element.js";
import template from "./ns-promo-hero.html";

import "@nuskin/ns-style-elements";

/**
 * The ns-promo-hero should be used for
 *
 * <h1>promo-hero</h1>
 * <demo-snippet>
 *   <template>
 *     <ns-promo-hero class="demoElement"></ns-promo-hero>
 *   </template>
 * </demo-snippet>
 *
 */
class NsPromoHero extends PolymerElement {
  constructor() {
    super();
  }

  ready() {
    super.ready();
    this._cleanUpImageURLs();
  }

  static get is() {
    return "ns-promo-hero";
  }

  static get template() {
    let htmlElement = document.createElement("TEMPLATE");
    htmlElement.innerHTML = template;
    return htmlElement;
  }

  static get properties() {
    return {
      /**
       * Accent color, in hex format
       */
      accentColor: {
        type: String,
        value: "#FFFFFF"
      },
      /**
       * Text align left, center, or right
       */
      copyAlign: {
        type: String,
        value: "left",
        reflectToAttribute: true
      },
      /**
       * Href for the CTA
       */
      ctaHref: {
        type: String,
        value: ""
      },
      /**
       * Type of CTA
       * link / darkButton / lightButton
       */
      ctaType: {
        type: String,
        value: "link",
        reflectToAttribute: true
      },
      /**
       * Alignment of the entire block reserved for copy
       * left / center / right
       */
      headAlign: {
        type: String,
        value: "left",
        reflectToAttribute: true
      },
      /**
       * Images
       * "head" is for above the copy block
       * { "head": "", "featured": "", "secondary": "", "tertiary": "" }
       */
      imageSet: {
        type: Object,
        value: {
          head: "",
          featured: "",
          secondary: "",
          tertiary: ""
        }
      },
      /**
       * Alt text for images
       * "head" is for above the copy block
       * { "head": "", "featured": "", "secondary": "", "tertiary": "" }
       */
      altTextSet: {
        type: Object,
        value: {
          head: "",
          featured: "",
          secondary: "",
          tertiary: ""
        }
      },
      /**
       * Background texture for the full bleed background
       */
      texture: {
        type: String,
        value: "",
        observer: "_setTexture"
      },
      /**
       * Theme of text color to complement the accent color
       * light / dark
       */
      theme: {
        type: String,
        value: "light",
        reflectToAttribute: true
      },
      /**
       * Translations object
       * { "ctaCopy": "" }
       */
      translations: {
        type: Object,
        value: {
          ctaCopy: ""
        }
      }
    };
  }

  /**
   * Strips clutter out of URLs
   */
  _cleanUpImageURLs() {
    if (this.imageSet) {
      for (let key in this.imageSet) {
        if (this.imageSet.hasOwnProperty(key)) {
          this.imageSet[key] = encodeURI(this.imageSet[key]);
        }
      }
    }
  }

  /**
   * Sets the full bleed background texture image
   */
  _setTexture() {
    this.updateStyles({
      "--promo-hero__texture": "url(" + this.texture + ")"
    });
  }
}
customElements.define(NsPromoHero.is, NsPromoHero);
